<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-data-check`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M33 2l9 9.429V24h-4v-9.962l-8 .001L29.999 6H10v36h14v4H8a2 2 0 01-2-2V4a2 2 0 012-2h25zm9.85 29.293l1.413 1.414a1 1 0 010 1.414L35.785 42.6l-.007.007-1.414 1.414a.996.996 0 01-.53.277l-.118.014h-.118a.996.996 0 01-.648-.291l-5.657-5.657a1 1 0 010-1.414l1.414-1.415a1 1 0 011.414 0l3.536 3.536 7.778-7.778a1 1 0 011.414 0zM23 27a1 1 0 011 1v2a1 1 0 01-1 1h-8a1 1 0 01-1-1v-2a1 1 0 011-1h8zm6-9a1 1 0 011 1v2a1 1 0 01-1 1H15a1 1 0 01-1-1v-2a1 1 0 011-1h14z"/></svg>
</template>
<script>

export default {
  name: 'IconDataCheck',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
